<template>

    <section>
        <!-- ここから -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center">
            <div class="main"><span>チーム管理</span></div>
            <div class="controller flex _right _y-center">
                <div>
                    <Link class="btn_link md_icon-text _white" href=""><div class="inner">
                        <span>
                            メンバー招待
                            <div class="icon">
                                <SvgIconSend />
                            </div>
                        </span>
                    </div></Link>
                </div><!--/.add-->
            </div><!--/.controller-->
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            TeamList
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="team_component">

            <!-- TeamList -->
            <ul class="team_list">

                <!-- Item -->
                <li>
                    <div class="inner">

                        <!-- Avatar -->
                        <div class="avatar">
                            <img src="/img/smp/001.jpg" alt="">
                        </div><!-- /.avatar -->

                        <!-- Detail -->
                        <div class="detail">
                            <div class="role _admin"><span>管理者</span></div>
                            <div class="name"><span>大分 太郎</span></div>
                            <div class="email"><span>example@example.com example@example.com example@example.com</span></div>
                        </div><!-- /Detail -->

                        <!-- 02/25 追加ここから -->
                        <!-- Delete -->
                        <div class="delete">
                            <button class="btn_svg-icon" data-modal="ModalOpenTeamDelete">
                                <SvgIconDelete />
                            </button>
                        </div><!-- /Delete -->
                        <!-- 02/25 追加ここまで -->

                        <!-- Edit -->
                        <div class="edit">
                            <button class="btn_svg-icon" data-modal="ModalOpenAdminSetting">
                                <SvgIconEdit />
                            </button>
                        </div><!-- /Edit -->

                    </div>
                </li><!-- Item -->

                <!-- Item -->
                <li>
                    <div class="inner">

                        <!-- Avatar -->
                        <div class="avatar">
                            <img src="/img/smp/001.jpg" alt="">
                        </div><!-- /.avatar -->

                        <!-- Detail -->
                        <div class="detail">
                            <div class="role "><span>一般</span></div>
                            <div class="name"><span>大分 太郎</span></div>
                            <div class="email"><span>example@example.com</span></div>
                        </div><!-- /Detail -->

                        <!-- 02/25 追加ここから -->
                        <!-- Delete -->
                        <div class="delete">
                            <button class="btn_svg-icon" data-modal="ModalOpenTeamDelete">
                                <SvgIconDelete />
                            </button>
                        </div><!-- /Delete -->
                        <!-- 02/25 追加ここまで -->

                    </div>
                </li><!-- Item -->

                <!-- Item -->
                <li>
                    <div class="inner">

                        <!-- Avatar -->
                        <div class="avatar">
                            <img src="/img/smp/001.jpg" alt="">
                        </div><!-- /.avatar -->

                        <!-- Detail -->
                        <div class="detail">
                            <div class="role "><span>一般</span></div>
                            <div class="name"><span>大分 太郎</span></div>
                            <div class="email"><span>example@example.com</span></div>
                        </div><!-- /Detail -->

                        <!-- 02/25 追加ここから -->
                        <!-- Delete -->
                        <div class="delete">
                            <button class="btn_svg-icon" data-modal="ModalOpenTeamDelete">
                                <SvgIconDelete />
                            </button>
                        </div><!-- /Delete -->
                        <!-- 02/25 追加ここまで -->

                    </div>
                </li><!-- Item -->

            </ul><!-- /ul.team-list -->

        </div><!-- /.team_component -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Modal1
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container ModalOpenAdminSetting">
            <div class="modal_wrap">

                <!-- Title -->
                <div class="modal_title">
                    <h3><span>どのユーザーに管理者権限を譲渡しますか？</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div class="inner">
                        <p><span class="md_text-bold _link-color">[管理者ユーザーネーム]</span> から</p>
                        <p>
                            <!-- SelectItem -->
                            <div class="item form_select" style="margin: 1rem 0;">
                                <div class="input-row">
                                    <select name="" id="">
                                        <option value="">大分 太郎2</option>
                                        <option value="">大分 太郎3</option>
                                    </select>
                                </div>
                            </div>
                        </p>
                        <p>へ変更</p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link _cancel md_icon-text js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                        </div>
                    </button>

                    <button class="btn_link md_icon-text _white">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>決定</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalOpenTeamDelete
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container _delete ModalOpenTeamDelete">
            <div class="modal_wrap">

                <!-- Title -->
                <div class="modal_title">
                    <h3><span>削除しますか？</span></h3>
                </div>

                <!-- Body -->
                <div class="modal_body">
                    <div class="inner">
                        <p>
                            <span class="md_text-bold _link-color">hogehoge</span> をチームから削除しようとしています。本当に削除してよろしいですか？
                        </p>
                    </div>
                </div>

                <!--btn-link-wrap-->
                <div class="btn_link-wrap">

                    <button class="btn_link _cancel md_icon-text js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                        </div>
                    </button>

                    <button class="btn_link md_icon-text _white _delete js-modal-close">
                        <div class="inner">
                            <span><div class="icon"><SvgIconDelete /></div>削除する</span>
                        </div>
                    </button>

                </div><!--/.btn-link-wrap-->

            </div>
            <div class="modal_close-ovl js-modal-close"></div>
        </div>

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalBackGround
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_bg"></div>

        <!-- ここまで -->

    </section>

</template>


<script>
    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            //Svg
            SvgIconEdit,
            SvgIconCancel,
            SvgIconCheck,
            SvgIconSend,
            SvgIconDelete,
        },
    }
</script>
